import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import globalTranslations from '../../../../i18n/globalTranslations';
import { modelOf } from '../../../../prop-types';
import CheckoutStore from '../../../../store/CheckoutStore';
import CheckoutPageModule from '../../../../types/checkout/CheckoutPageModule';
import CheckoutModule from '../../common/CheckoutModule';
import CheckoutCustomerCountry from "../CheckoutCustomerCountry";

const CheckoutCustomerCountryModule = ({
  checkoutStore,
  onOrderUpdate,
  orderNumber,
}) => {
  const { order } = checkoutStore;
  const { customerCountryAlerts } = order;

  const handleUpdate = ({ withoutTimer }) => {
    onOrderUpdate({
      module: CheckoutPageModule.CUSTOMER_COUNTRY_MODULE,
      withoutTimer,
    });
  };

  return (
    <CheckoutModule
      className="CheckoutCustomerCountryModule"
      generalAlerts={customerCountryAlerts.general}
      errorAlerts={customerCountryAlerts.errors}
      title={<FormattedMessage {...globalTranslations.countryTitle} />}
      orderNumber={orderNumber}
      module={CheckoutPageModule.CUSTOMER_COUNTRY_MODULE}
    >
      <CheckoutCustomerCountry
        onOrderUpdate={handleUpdate}
        orderNumber={orderNumber}
      />
    </CheckoutModule>
  );
};

CheckoutCustomerCountryModule.propTypes = {
  checkoutStore: modelOf(CheckoutStore).isRequired,
  onOrderUpdate: PropTypes.func.isRequired,
  orderNumber: PropTypes.number.isRequired,
};

export default inject(
  'checkoutStore'
)(observer(CheckoutCustomerCountryModule));
